@if (equipment) {
  <app-consignment-details-alerts></app-consignment-details-alerts>
  <div class="modal-header">
    <div class="flex-container align-items-center">
      <button type="button" class="btn-close me-2 d-inline-flex" data-bs-dismiss="modal" aria-label="Close"></button>
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg fa-file-lines text-muted"></i>
      </div>
      <button class="btn btn-link p-0 page-title align-baseline" (click)="processModelAndOpenMasterConsignment()">
        <span class="page-title">{{ consignmentProcess.consignmentMasterLevel.consignmentNumber }}</span>
      </button>
      @if (consignmentProcess.cancelled) {
        <app-tooltip placement="bottom" class="ms-2">
          <span class="fa text-danger fa-fw fa-ban"></span>
          <span class="tooltipContent">Cancelled</span>
        </app-tooltip>
      }
      <div class="d-inline-flex mx-2">
        <i class="fa fa-fw fa-light fa-lg fa-chevron-right text-muted"></i>
      </div>
      @if (houseConsignment) {
        <div class="d-inline-flex me-1">
          <i class="fa fa-kit fa-fw fa-light fa-lg fa-pb-file-line text-muted"></i>
        </div>
        <button class="btn btn-link p-0 page-title align-baseline" (click)="processModelAndOpenHouseConsignment()">
          <span class="page-title">{{ houseConsignment.consignmentNumber }}</span>
        </button>
        <div class="d-inline-flex mx-2">
          <i class="fa fa-fw fa-light fa-lg fa-chevron-right text-muted"></i>
        </div>
      }
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg text-muted"
           [ngClass]="utils.getEquipmentIconCls(equipment.containerSizeAndType, equipment.empty)"></i>
      </div>
      <span class="page-title">{{ equipment.containerIdentificationNumber }}</span>
      @if (isShortLanded) {
        <app-tooltip placement="bottom" class="ms-2">
          <span class="fa text-danger fa-fw fa-exclamation-triangle"></span>
          <span class="tooltipContent">Equipment is shortlanded</span>
        </app-tooltip>
      }
    </div>
  </div>
  <div class="modal-body p-0">
    <app-tab-panel [sticky]="true" [alwaysRender]="true" (tabChange)="onTabChange($event)">
      <app-tab-item [templateRef]="detailsRef">
        <span class="tab-item">
          <span errorIndicator [predicate]="detailsPredicate" [overrideRef]="elementRef"></span>
          <span>Details</span>
        </span>
        <ng-template #detailsRef>
          <div class="container py-3">
            <div class="card">
              <div class="card-body p-5">
                <div class="row gy-4 my-0">
                  <h5 class="h1 col-12 m-0">Equipment details</h5>
                  <div class="col-12">
                    <div class="row gy-4">
                      <app-form-field label="Equipment number" class="col-6 col-md-3"
                                      [(value)]="equipment.containerIdentificationNumber"
                                      [includeMargin]="false" [editMode]="editMode && isNewEquipment"
                                      [renderOptional]="false"
                                      [checkForErrors]="true">
                        <input #equipmentNumberField="fieldValidator" class="input-group form-control"
                               [(ngModel)]="equipment.containerIdentificationNumber"
                               [fieldValidator]="isNewEquipment ? validateContainerNumber : null" required
                               stripHiddenCharacters/>
                      </app-form-field>
                      <app-form-field label="Empty" class="col-6 col-md-2"
                                      [(value)]="equipment.empty" [formatter]="emptyIndicatorFormatter"
                                      [includeMargin]="false" [editMode]="editMode" [renderOptional]="false"
                                      [compare]="containerProcess?.terminalData?.empty"
                                      compareHeader="New data from Terminal">
                        <app-yes-no [(ngModel)]="equipment.empty"></app-yes-no>
                      </app-form-field>
                      <app-form-field label="Booking reference" class="col-12 col-md-4" [renderOptional]="true"
                                      [(value)]="equipment.bookingReference" [includeMargin]="false"
                                      [editMode]="editMode">
                        <input class="input-group form-control"
                               [(ngModel)]="equipment.bookingReference"/>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Size type" class="col-12 col-md-5"
                                      [(value)]="equipment.containerSizeAndType" [editMode]="editMode"
                                      [formatter]="utils.sizeTypeFormatter" [includeMargin]="false"
                                      [compare]="containerProcess?.terminalData?.sizeType"
                                      compareHeader="New data from Terminal"
                                      [compareMethod]="compareSizeTypeByCode">
                        <app-search [(ngModel)]="equipment.containerSizeAndType" [searchFunction]="utils.findSizeTypes"
                                    [inputFormatter]="utils.sizeTypeFormatter"
                                    (ngModelChange)="equipmentNumberField.checkFieldValidity()"
                                    placeholder="Size or type, e.g. 22G1" dataKey="name" required>
                        </app-search>
                      </app-form-field>
                      <app-form-field label="Container operator" class="col-12 col-md-4"
                                      [(value)]="equipment.containerOperator" [editMode]="editMode"
                                      [includeMargin]="false" [formatter]="utils.carrierFormatter"
                                      [compare]="containerProcess?.terminalData?.containerOperator"
                                      compareHeader="New data from Terminal">
                        <app-search [(ngModel)]="equipment.containerOperator" [required]="isDutchPort"
                                    [searchFunction]="utils.findCarriers" [resultFormatter]="utils.carrierFormatter"
                                    [inputFormatter]="utils.carrierFormatter">
                        </app-search>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Supplier" class="col-12 col-md-3"
                                      [(value)]="equipment.containerSupplierType" [editMode]="editMode"
                                      [formatter]="utils.supplierTypeFormatter" [includeMargin]="false">
                        <app-search [(ngModel)]="equipment.containerSupplierType" required
                                    [options]="utils.supplierTypes"
                                    [inputFormatter]="utils.supplierTypeFormatter"></app-search>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Oversized" class="col-12 col-md-6"
                                      [(value)]="oversize" [includeMargin]="false" [editMode]="editMode"
                                      [compare]="terminalDataOversize" compareHeader="New data from Terminal">
                        <app-yes-no [(ngModel)]="oversize"></app-yes-no>
                      </app-form-field>
                    </div>
                  </div>
                  @if (oversize) {
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="Overlength (m)" class="col-12 col-md-2" [renderOptional]="false"
                                        [(value)]="equipment.oversize.overlength" [includeMargin]="false"
                                        [editMode]="editMode"
                                        [compare]="containerProcess?.terminalData?.oversize?.overlength"
                                        compareHeader="New data from Terminal">
                          <input class="input-group form-control" type="number"
                                 [(ngModel)]="equipment.oversize.overlength"/>
                        </app-form-field>
                        <app-form-field label="Overwidth (m)" class="col-12 col-md-2" [renderOptional]="false"
                                        [(value)]="equipment.oversize.overwidth" [includeMargin]="false"
                                        [editMode]="editMode"
                                        [compare]="containerProcess?.terminalData?.oversize?.overwidth"
                                        compareHeader="New data from Terminal">
                          <input class="input-group form-control" type="number"
                                 [(ngModel)]="equipment.oversize.overwidth"/>
                        </app-form-field>
                        <app-form-field label="Overheight (m)" class="col-12 col-md-2" [renderOptional]="false"
                                        [(value)]="equipment.oversize.overheight" [includeMargin]="false"
                                        [editMode]="editMode"
                                        [compare]="containerProcess?.terminalData?.oversize?.overheight"
                                        compareHeader="New data from Terminal">
                          <input class="input-group form-control" type="number"
                                 [(ngModel)]="equipment.oversize.overheight"/>
                        </app-form-field>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="Oversize remarks" class="col-12 col-md-6" [renderOptional]="true"
                                        [(value)]="equipment.oversize.remarks" [includeMargin]="false"
                                        [editMode]="editMode"
                                        [compare]="containerProcess?.terminalData?.oversize?.remarks"
                                        compareHeader="New data from Terminal">
                          <input class="input-group form-control"
                                 [(ngModel)]="equipment.oversize.remarks"/>
                        </app-form-field>
                      </div>
                    </div>
                  }
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Tare weight (kg)" class="col-6 col-md-3"
                                      [(value)]="equipment.tareWeight" [editMode]="editMode"
                                      [includeMargin]="false"
                                      [compare]="containerProcess?.terminalData?.tareWeight"
                                      compareHeader="New data from Terminal">
                        <input class="input-group form-control" type="number"
                               [(ngModel)]="equipment.tareWeight"/>
                      </app-form-field>
                    </div>
                  </div>
                  @if (isNewEquipment && data.goodsItem) {
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="Gross weight (kg)" class="col-12 col-md-6"
                                        [(value)]="placement.grossWeight" [editMode]="editMode"
                                        [includeMargin]="false">
                          <input class="input-group form-control" type="number" step="any" required
                                 [(ngModel)]="placement.grossWeight"/>
                        </app-form-field>
                        <app-form-field label="Number of packages" class="col-12 col-md-6"
                                        [(value)]="placement.numberOfPackages" [editMode]="editMode"
                                        [includeMargin]="false">
                          <input class="input-group form-control" type="number" required
                                 [(ngModel)]="placement.numberOfPackages"/>
                        </app-form-field>
                      </div>
                    </div>
                  }
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Temperature (°C)" class="col col-md-3"
                                      [(value)]="equipment.temperature" [editMode]="editMode" [includeMargin]="false"
                                      [compare]="containerProcess?.terminalData?.temperature"
                                      compareHeader="New data from Terminal">
                        <input class="input-group form-control" type="number"
                               [(ngModel)]="equipment.temperature"/>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Seals" class="col-6 col-md-7"
                                      [(value)]="equipment.sealIdentifiers" [editMode]="editMode"
                                      [formatter]="sealIdentifiersFormatter" [includeMargin]="false"
                                      [checkForErrors]="true">
                        <app-tags [(ngModel)]="equipment.sealIdentifiers" placeholder="Add Seal" [readonly]="!editMode"
                                  class="input-group form-control"></app-tags>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Redelivery address" class="col col-md-5"
                                      [(value)]="equipment.redeliveryAddress" [editMode]="editMode"
                                      [includeMargin]="false">
                        <input class="input-group form-control"
                               [(ngModel)]="equipment.redeliveryAddress"/>
                      </app-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-tab-item>
      <app-tab-item [templateRef]="goodsRef">
        <span class="tab-item">Goods</span>
        <ng-template #goodsRef>
          <app-consignment-goods-table [data]="goodsItems" [consignmentProcess]="consignmentProcess"
                                       [houseConsignment]="houseConsignment"
                                       [equipmentNumber]="equipment.containerIdentificationNumber"></app-consignment-goods-table>
        </ng-template>
      </app-tab-item>
    </app-tab-panel>
  </div>
  @if (!consignmentProcess.fromVisit) {
    <div class="modal-footer">
      <div class="d-flex flex-grow-1">
        <div class="container">
          <div class="row mx-4">
            <div class="col-auto">
              <button type="button" class="btn btn-outline-danger" (click)="remove()">Remove</button>
            </div>
            <div class="col-auto ms-auto">
              @if (!editMode) {
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close"
                >
                  Close
                </button>
              }
              @if (editMode) {
                <button type="button" class="btn btn-outline-secondary" (click)="toggleEdit()">
                  Cancel
                </button>
              }
            </div>
            <div class="col-auto">
              @if (editMode) {
                @if (hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="toggleEdit()">
                    Ok
                  </button>
                }
                @if (!hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    Save
                  </button>
                }
              } @else {
                @if (isEditableForTab) {
                  <button type="button" class="btn btn-outline-secondary me-4" (click)="toggleEdit()">
                    Edit
                  </button>
                }
                @if (allowedToDeclare && hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    {{consignmentProcess?.cancelled ? "Re-open" : "Update"}}
                  </button>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
